'use client';

import React from 'react';
import { cn } from '@/lib/utils';

export interface GlassPanelProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: 'default' | 'header' | 'glow';
  noPadding?: boolean;
}

const variantClasses = {
  default:
    'border border-neon-cyan/10 bg-panel/95 backdrop-blur-md shadow-sm',
  header:
    'border border-neon-cyan/10 bg-panel/95 backdrop-blur-md shadow-glow-cyan overflow-hidden',
  glow:
    'border border-neon-cyan/15 bg-panel/95 backdrop-blur-md shadow-glow-cyan',
};

const GlassPanel = React.forwardRef<HTMLDivElement, GlassPanelProps>(
  ({ children, className, variant = 'default', noPadding = false, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          'rounded-xl transition-colors',
          variantClasses[variant],
          !noPadding && 'p-6',
          className
        )}
        {...props}
      >
        {children}
      </div>
    );
  }
);

GlassPanel.displayName = 'GlassPanel';

export default GlassPanel;
